import { useOutletContext } from 'react-router'

import { FacebookAdAccount, GoogleAdwordsAdAccount } from 'app/connections/types'
import { GoogleAnalyticsAccount } from 'app/connections/types/googleAnalytics'

import { StepContext } from './StepWithConnectionAndAccounts'
import CriteoSettings from './accounts-and-ids/CriteoSettings'
import DV360Settings from './accounts-and-ids/DV360Settings'
import FacebookSettings from './accounts-and-ids/FacebookSettings'
import GoogleAdwordsSettings from './accounts-and-ids/GoogleAdwordsSettings'
import GoogleAnalyticsSettings from './accounts-and-ids/GoogleAnalyticsSettings'

const Settings = <
  A extends FacebookAdAccount | GoogleAdwordsAdAccount | GoogleAnalyticsAccount,
>() => {
  const { connection: connection } = useOutletContext<StepContext<A>>()

  switch (connection.name) {
    case 'criteo':
      return <CriteoSettings />
    case 'dv360':
      return <DV360Settings />
    case 'facebook':
      return <FacebookSettings />
    case 'googleAdwords':
      return <GoogleAdwordsSettings />
    case 'googleAnalytics':
      return <GoogleAnalyticsSettings />

    default:
      return <></>
  }
}

export default Settings
